export const GIFT_CARD = 'Gift Card';
export const DELIVERY = 'DELIVERY';
export const PICKUP = 'PICKUP';
export const CATERING = 'CATERING';
export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
